// Global slider
function initAllSliders() {
  document.querySelectorAll('.slider-sec__wrap').forEach(function(sectionWrapper) {
    // Agar pehle se swiper initialized hai toh destroy karo
    if (sectionWrapper.swiper) {
      sectionWrapper.swiper.destroy(true, true);
      sectionWrapper.swiper = null;
    }

    const slidesMobile = parseFloat(sectionWrapper.dataset.slidesMobile) || 1.2;
    const slidesTablet = parseFloat(sectionWrapper.dataset.slidesTablet) || 2.5;
    const slidesDesktop = parseFloat(sectionWrapper.dataset.slidesDesktop) || 4;

    const groupMobile = parseFloat(sectionWrapper.dataset.groupMobile) || 1;
    const groupTablet = parseFloat(sectionWrapper.dataset.groupTablet) || 1;
    const groupDesktop = parseFloat(sectionWrapper.dataset.groupDesktop) || 1;

    const spaceMobile = parseInt(sectionWrapper.dataset.spaceMobile) || 10;
    const spaceTablet = parseInt(sectionWrapper.dataset.spaceTablet) || 15;
    const spaceDesktop = parseInt(sectionWrapper.dataset.spaceDesktop) || 20;

    const loopSlider = sectionWrapper.dataset.loop === 'true';

    const arrowsMobile = sectionWrapper.dataset.arrowsMobile === 'true';
    const arrowsTablet = sectionWrapper.dataset.arrowsTablet === 'true';
    const arrowsDesktop = sectionWrapper.dataset.arrowsDesktop === 'true';

    const nextBtn = sectionWrapper.querySelector('.swiper-button-next');
    const prevBtn = sectionWrapper.querySelector('.swiper-button-prev');

    function updateArrowVisibility() {
      const width = window.innerWidth;
      if (nextBtn && prevBtn) {
        if (width < 767) {
          nextBtn.style.display = prevBtn.style.display = arrowsMobile ? 'block' : 'none';
        } else if (width >= 767 && width < 1280) {
          nextBtn.style.display = prevBtn.style.display = arrowsTablet ? 'block' : 'none';
        } else {
          nextBtn.style.display = prevBtn.style.display = arrowsDesktop ? 'block' : 'none';
        }
      }
    }

    sectionWrapper.swiper = new Swiper(sectionWrapper, {
      slidesPerView: slidesMobile,
      slidesPerGroup: groupMobile,
      spaceBetween: spaceMobile,
      loop: loopSlider,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      breakpoints: {
        767: {
          slidesPerView: slidesTablet,
          slidesPerGroup: groupTablet,
          spaceBetween: spaceTablet
        },
        1280: {
          slidesPerView: slidesDesktop,
          slidesPerGroup: groupDesktop,
          spaceBetween: spaceDesktop
        }
      }
    });

    updateArrowVisibility();

    // Resize listener (duplicate prevent karne ke liye named function)
    if (!sectionWrapper._resizeListener) {
      sectionWrapper._resizeListener = updateArrowVisibility;
      window.addEventListener('resize', sectionWrapper._resizeListener);
    }
  });
}

// Page load pe run karo
initAllSliders();

// Shopify Customizer events
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  // Yeh events tab fire hote hain jab settings change ho
  document.addEventListener('shopify:section:load', initAllSliders);
  document.addEventListener('shopify:section:rerender', initAllSliders);  // ← Yeh missing tha
  document.addEventListener('shopify:section:select', initAllSliders);
  document.addEventListener('shopify:block:select', initAllSliders);      // ← Yeh bhi missing tha

  document.addEventListener('shopify:section:unload', function(e) {
    // Sirf us section ke sliders destroy karo jo unload ho raha hai
    if (e.target) {
      e.target.querySelectorAll('.slider-sec__wrap').forEach(function(sectionWrapper) {
        if (sectionWrapper.swiper) {
          sectionWrapper.swiper.destroy(true, true);
          sectionWrapper.swiper = null;
        }
        if (sectionWrapper._resizeListener) {
          window.removeEventListener('resize', sectionWrapper._resizeListener);
          sectionWrapper._resizeListener = null;
        }
      });
    }
  });
}

// Global Readmore

document.addEventListener("DOMContentLoaded", function () {

  function initReadMore(container) {

    if (!container) return;

    const enabled = container.dataset.readmore === "true";
    const limit = parseInt(container.dataset.words || "25");

    if (!enabled) return;

    let isExpanded = false;
    const fullHTML = container.innerHTML;

    function collapse() {

      const pTags = Array.from(container.children).filter(el => el.tagName === "P");

      pTags.forEach((p, index) => {

        if (index === 0) {

          let wordCount = 0;
          let resultHTML = "";
          let done = false;

          p.childNodes.forEach(node => {
            if (done) return;

            if (node.nodeType === Node.TEXT_NODE) {
              const words = node.textContent.split(/\s+/).filter(w => w.length > 0);

              for (let i = 0; i < words.length; i++) {
                if (wordCount < limit) {
                  resultHTML += (wordCount === 0 ? "" : " ") + words[i];
                  wordCount++;
                } else {
                  done = true;
                  break;
                }
              }

              if (!done && /\s$/.test(node.textContent)) {
                resultHTML += " ";
              }

            } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName === "BR") {
              if (wordCount < limit) {
                resultHTML += "<br>";
              }
            }
          });

          p.innerHTML = `${resultHTML}<strong class="rm-toggle" style="cursor:pointer;"> Read more</strong>`;
          p.style.display = "block";

        } else {
          p.style.display = "none";
        }

      });
    }

    function expand() {
      container.innerHTML = fullHTML;

      const pTags = Array.from(container.children).filter(el => el.tagName === "P");

      const last = pTags[pTags.length - 1];

      if (last) {
        last.innerHTML += ` <strong class="rm-toggle" style="cursor:pointer;">Read less</strong>`;
      }
    }

    function toggle() {
      isExpanded = !isExpanded;
      isExpanded ? expand() : collapse();
    }

    collapse();

    container.addEventListener("click", function (e) {
      if (e.target.classList.contains("rm-toggle")) {
        toggle();
      }
    });

  }

  document.querySelectorAll("[data-readmore='true']")
    .forEach(initReadMore);

});